<div class="modal-header" [ngClass]="iconTypeLayoutClass()">
  <button class="close" aria-label="Close" (click)="closeModal()" [ngClass]="iconCustomLayoutClass()">
    <img src="/assets/images/bt-close.svg" width="28px" height="28px" />
  </button>
</div>

<div class="modal-body">

   <!-- Description -->
   <div class="form-group row" [ngClass]="iconTypeLayoutClass()">
    <div class="col-sm-12 text-center">
      <i class="fas fa-exclamation-circle large-font"></i>

      <br>
      <br>
      <h2>{{ getTranslate("title") }}</h2>
      <br>
      <p>{{ getTranslate("descriptionConfirm") + ' ' }} <strong *ngIf="model !== null && model !== undefined && model.email !== undefined"
                                         [innerHTML]="model.email"></strong></p>
      <br>
      <br>
      <p>{{ getTranslate("accessToConfirm") }}</p>
      <br>
      <br>
      <br>
      <a class="action-link" (click)="resend()">{{ getTranslate("resendEmail") }}</a>
      <br *ngIf="mailSent">
      <br *ngIf="mailSent">
      <p *ngIf="mailSent">{{ getTranslate("emailSend") }}</p>
    </div>
  </div>
  <!-- ./ Description -->

</div>

<div class="modal-footer text-center">
  <button type="reset"
          [style.border]="'1px solid transparent'"
          (click)="closeModal(true)"
          class="btn btn-success small-btn no-margin-top no-margin-bottom"
          [ngClass]="buttonCustomLayoutCss()">
    {{ getTranslate("alreadyConfirmed") }}
  </button>
</div>
